import React from "react";
import LayoutPagePublications from "@/layout/pages/publications";
import { GetServerSideProps, GetServerSidePropsContext } from "next";
import { Viewport } from "@/types/enum";
import { PagedItems } from "@/types/contenu";
import { Categorie } from "@/types/categorie";
import { SERVER_SIDE_CACHE_HEADER } from "@/configs/cache";

type RecettesCategoriesProps = {
    data: Categorie[];
    viewport: Viewport;
};

const RecettesCategories = ({ data, viewport }: RecettesCategoriesProps) => (
    <LayoutPagePublications
        contenu={data}
        viewport={viewport}
        boutonTitle="Voir toutes les recettes"
        sectionTitle="Toutes les recettes"
        title="Recettes"
    />
);

export const getServerSideProps = (async ({ res, query }: GetServerSidePropsContext) => {
    const api = process.env.SERVER_API_URL;

    res.setHeader("Cache-Control", SERVER_SIDE_CACHE_HEADER);

    const response = await fetch(`${api}/v1/categories/type/recette`);
    const viewport = query["viewport"] || "desktop";

    const json: PagedItems<Categorie> = await response.json();

    return {
        props: {
            data: json.items.sort((a, b) => a.ordre - b.ordre),
            viewport: viewport,
        },
    };
}) satisfies GetServerSideProps;

export default RecettesCategories;
